import {Messaging, getMessaging, getToken, onMessage} from 'firebase/messaging';

import getFirebaseApp from './app.web';

const AUTHORIZED_STATUS = 1;
const PROVISIONAL_STATUS = 2;
const REJECTED_STATUS = 0;

let messagingConnector: Messaging | null = null;
let firebaseToken: string = '';

export const onMessageListener = () =>
  new Promise(resolve => {
    if (messagingConnector) {
      onMessage(messagingConnector, payload => {
        resolve(payload);
      });
    }
  });

const messaging = () => {
  if (messagingConnector == null) {
    const firebaseApp = getFirebaseApp();
    messagingConnector = getMessaging(firebaseApp);
  }

  return {
    onMessage: (callback: (value: any) => void) => {
      if (messagingConnector) {
        onMessage(messagingConnector, callback);
      }
    },
    onNotificationOpenedApp: (callback: (value: any) => void) => {
      console.debug(
        'firebase messaging onNotificationOpenedApp callback:',
        callback,
      );
    },
    getInitialNotification: () => {
      return null;
    },
    requestPermission: async () => {
      if (messagingConnector) {
        firebaseToken = await getToken(messagingConnector, {
          vapidKey:
            'BBAac5w7GW44fZRW2U4T717Y63wStTv2OHdrwhwXsNxLc1iHkUPO182Im78d7v__QHfrPC6tJJ6084yyck2jpoA',
        });
        return AUTHORIZED_STATUS;
      }

      return REJECTED_STATUS;
    },
    getToken: async () => {
      return firebaseToken;
    },
  };
};

messaging.AuthorizationStatus = {
  AUTHORIZED: AUTHORIZED_STATUS,
  PROVISIONAL: PROVISIONAL_STATUS,
};

export default messaging;
